import { StaticLayout } from './static-layout'

export function PrivacyPage() {
  return (
    <StaticLayout title="Privacy policy" description="Last updated: 2026-05-13">
      <h2>Summary</h2>
      <p>
        We collect the minimum needed to run the service. We don&apos;t sell your data and we
        don&apos;t use third-party trackers inside the editor.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Account data</strong> — name and email when you register; password stored as a
          one-way hash.
        </li>
        <li>
          <strong>Document content</strong> — markdown content you create, including the
          collaborative edit history needed to reconcile real-time changes.
        </li>
        <li>
          <strong>Session cookies</strong> — an httpOnly session cookie set by our backend on
          login; required for authentication.
        </li>
        <li>
          <strong>Operational logs</strong> — IP, user agent and request path are temporarily
          logged for abuse prevention and rotated regularly.
        </li>
      </ul>

      <h2>What we do not collect</h2>
      <ul>
        <li>We do not embed analytics or advertising trackers inside the editor.</li>
        <li>We do not sell or rent your data.</li>
      </ul>

      <h2>Your rights</h2>
      <p>
        You may request a copy of your data or delete your account by contacting us via the{' '}
        <a href="/contact">contact page</a>.
      </p>
    </StaticLayout>
  )
}
